import { render, staticRenderFns } from "./AccountsReceivableTrend.vue?vue&type=template&id=ee5a4152&scoped=true"
import script from "./AccountsReceivableTrend.vue?vue&type=script&lang=js"
export * from "./AccountsReceivableTrend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee5a4152",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee5a4152')) {
      api.createRecord('ee5a4152', component.options)
    } else {
      api.reload('ee5a4152', component.options)
    }
    module.hot.accept("./AccountsReceivableTrend.vue?vue&type=template&id=ee5a4152&scoped=true", function () {
      api.rerender('ee5a4152', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/bulletinBoard/receivablesStatistics/AccountsReceivableTrend.vue"
export default component.exports